import * as React from "preact";
import cx from "classnames";
import { FunctionComponent } from "preact";

export interface ISavedItemsButton {
  text?: string;
  active?: boolean;
  onClick?: (e: MouseEvent) => void;
  contentId?: string | null;
  disabled?: boolean;
  getSaveListApiUrl?: string;
  updateSaveStateApiUrl?: string;
}

const SavedItemsButton: FunctionComponent<ISavedItemsButton> =
  ({
     active,
     text,
     onClick,
     contentId,
     disabled,
     getSaveListApiUrl,
     updateSaveStateApiUrl,
   }) => {
    return <button
      data-content-id={contentId}
      data-get-save-list-api-url={getSaveListApiUrl}
      data-update-save-state-api-url={updateSaveStateApiUrl}
      className={cx("saved-items-button", {
        ["active"]: active,
      })} data-save-text="Save" data-saved-text="Saved"
      onClick={onClick} disabled={disabled}>
      <svg className="saved-items-button__icon"
           xmlns="http://www.w3.org/2000/svg"
           width="22" height="23"
           viewBox="0 0 22 23" fill="currentColor">
        <path
          d="M19.7005 6.59128C18.8089 5.69986 17.6568 5.16325 16.4163 5.05246V2.15136C16.4163 1.24083 15.6752 0.5 14.7648 0.5H1.6515C0.74072 0.5 0 1.24083 0 2.15136V20.8457C0 21.4977 0.367993 22.0725 0.960394 22.3455C1.18515 22.4491 1.42183 22.4999 1.65641 22.4999C2.03983 22.4999 2.41694 22.3642 2.72445 22.1011L7.76292 17.7955C8.02064 17.5749 8.39512 17.5749 8.65319 17.7955L13.6915 22.1011C14.1875 22.525 14.8635 22.6186 15.4559 22.3456C16.0483 22.0727 16.4163 21.4979 16.4163 20.8459V15.6646C17.6568 15.5537 18.8089 15.0172 19.7005 14.1258C20.7069 13.1194 21.261 11.7817 21.261 10.3587C21.261 8.93579 20.7069 7.59769 19.7005 6.59163V6.59128ZM16.4163 14.6931C16.2576 14.7108 16.0963 14.7198 15.9331 14.7198C15.7699 14.7198 15.6084 14.7108 15.4499 14.6931C13.2714 14.4521 11.5715 12.5998 11.5715 10.3586C11.5715 8.11729 13.2714 6.26504 15.4499 6.02399C15.6084 6.00629 15.7697 5.99735 15.9331 5.99735C16.0965 5.99735 16.2576 6.00629 16.4163 6.02399C18.5948 6.26504 20.2947 8.11694 20.2947 10.3586C20.2947 12.6002 18.5948 14.4521 16.4163 14.6931ZM15.4498 20.8457C15.4498 21.1204 15.3007 21.3531 15.0514 21.4677C14.8018 21.5827 14.5281 21.5449 14.3195 21.3666L9.28118 17.0608C8.98226 16.8053 8.60112 16.6648 8.20806 16.6648C7.81499 16.6648 7.43403 16.8053 7.13511 17.0608L2.09663 21.3666C1.88783 21.5449 1.61416 21.5827 1.36485 21.4677C1.1152 21.3529 0.96653 21.1203 0.96653 20.8457V2.15136C0.96653 1.77376 1.27386 1.46627 1.65167 1.46627H14.7648C15.1426 1.46627 15.4499 1.77376 15.4499 2.15136V5.05246C14.209 5.16308 13.0572 5.69986 12.1657 6.59128C11.1594 7.59752 10.6052 8.93526 10.6052 10.3584C10.6052 11.7815 11.1594 13.1191 12.1657 14.1255C13.0572 15.0169 14.209 15.5537 15.4499 15.6643V20.8456L15.4498 20.8457Z"
          fill="currentColor" />
        <path
          id="plus"
          d="M18.3719 9.86437H16.405V7.9199C16.405 7.65292 16.1888 7.43677 15.9218 7.43677C15.6904 7.43677 15.4966 7.59962 15.4497 7.81718C15.4425 7.85031 15.4386 7.88449 15.4386 7.9199V9.86437H13.494C13.227 9.86437 13.0108 10.0809 13.0108 10.3475C13.0108 10.6141 13.227 10.8306 13.494 10.8306H15.4386V12.7974C15.4386 12.8326 15.4425 12.867 15.4497 12.9001C15.4965 13.1175 15.6904 13.2805 15.9218 13.2805C16.1888 13.2805 16.405 13.064 16.405 12.7974V10.8306H18.3719C18.6385 10.8306 18.855 10.6145 18.855 10.3475C18.855 10.0805 18.6385 9.86437 18.3719 9.86437Z"
          fill="currentColor" />
        <path
          id="minus"
          d="M18.3606 9.8645H13.4827C13.216 9.8645 12.9995 10.081 12.9995 10.3476C12.9995 10.6143 13.216 10.8308 13.4827 10.8308H18.3606C18.6276 10.8308 18.8437 10.6146 18.8437 10.3476C18.8437 10.0807 18.6276 9.8645 18.3606 9.8645Z"
          fill="currentColor" />
      </svg>

      {text && <span className="saved-items-button__text">{text}</span>}
    </button>;
  };

export default SavedItemsButton;
